/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const UsersRoleJsonApiModel = {
  id: "",
  user: {
    jsonApi: "hasOne",
    type: "users",
  },
  role: "",
  "created-at": "",
  "updated-at": "",
};
